module.exports = __webpack_public_path__ + "img/produkt-hranolky.d7455413.jpg";